import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpen, PlayCircle, Map, Stethoscope } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <BookOpen className="w-8 h-8 text-accent" data-id="element-166" />,
    title: 'El Manual Maestro "Reseteo de 4 Horas"',
    desc: 'El paso a paso exacto para aplicar la secuencia Neuro-Soothe.'
  }, {
    icon: <PlayCircle className="w-8 h-8 text-accent" data-id="element-167" />,
    title: 'Video-Demostración de Posiciones',
    desc: 'Para que no dudes ni un segundo si lo estás haciendo bien.'
  }, {
    icon: <Map className="w-8 h-8 text-accent" data-id="element-168" />,
    title: 'El Mapa del Masaje "I-L-U"',
    desc: 'La técnica de 2 minutos para evacuar gases rebeldes.'
  }, {
    icon: <Stethoscope className="w-8 h-8 text-accent" data-id="element-169" />,
    title: 'Checklist: El Botiquín de Emergencia',
    desc: 'Lo que debes tener en tu mesita de noche para no entrar en pánico.'
  }];
  return <section className="py-24 bg-cream" data-id="element-170">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-171">
        <FadeIn data-id="element-172">
          <div className="text-center mb-16" data-id="element-173">
            <h2 className="text-3xl md:text-4xl font-bold text-earth-darker mb-4" data-id="element-174">
              LO QUE OBTENDRÁS HOY:
            </h2>
            <div className="w-24 h-1 bg-accent mx-auto rounded-full" data-id="element-175" />
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-176">
          {items.map((item, idx) => <FadeIn key={idx} delay={idx * 0.1} className="flex gap-6 bg-white p-8 rounded-2xl shadow-sm border border-earth-light/40 group hover:border-accent/30 transition-colors" data-id="element-177">
              <div className="flex-shrink-0 w-16 h-16 bg-cream-dark rounded-xl flex items-center justify-center group-hover:bg-accent/10 transition-colors" data-id="element-178">
                {item.icon}
              </div>
              <div data-id="element-179">
                <h3 className="text-xl font-bold text-earth-darker mb-2" data-id="element-180">
                  {item.title}
                </h3>
                <p className="text-earth-dark leading-relaxed" data-id="element-181">{item.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}